export default "__VITE_ASSET__CtbetlQS__"